import type { CalendarTask } from './calendar_sync';
const days = ['Понеділок', 'Вівторок', 'Середа', 'Четвер', 'П’ятниця', 'Субота', 'Неділя'];
const short = ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Нд'];
const categories: Record<string, string> = {
    delivery: 'Доставка',
    school: 'Школа / ліцей',
    pum: 'Робота',
    sleep: 'Сон',
    commute: 'Дорога',
    meal: 'Їжа',
    routine: 'Побут',
    sport: 'Спорт',
    other: 'Інше',
};
const escape = (s: string) =>
    s.replace(
        /[&<>"']/g,
        (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]!
    );
const slotId = () =>
    `slot_${crypto.randomUUID?.() || `${Date.now()}_${Math.random().toString(36).slice(2)}`}`;
const normalizeTime = (raw: string) => {
    let value = raw.trim().replace('.', ':');
    if (/^\d{3,4}$/.test(value)) value = value.slice(0, -2) + ':' + value.slice(-2);
    const match = value.match(/^(\d{1,2})(?::(\d{1,2}))?$/);
    return match ? match[1].padStart(2, '0') + ':' + (match[2] || '00').padStart(2, '0') : value;
};
const minutes = (s: string) => {
    if (!/^(?:[01]\d|2[0-3]):[0-5]\d$/.test(s) && s !== '24:00') return NaN;
    return Number(s.slice(0, 2)) * 60 + Number(s.slice(3, 5));
};
(window as any).openScheduleEditor = function (
    source: CalendarTask[],
    save: (tasks: CalendarTask[]) => Promise<boolean>,
    selectedDay = 0,
    focusId?: string
) {
    document.getElementById('schedule-editor')?.remove();
    let draft: CalendarTask[] = structuredClone(source),
        day = selectedDay;
    const dialog = document.createElement('dialog');
    dialog.id = 'schedule-editor';
    dialog.className = 'schedule-editor-dialog';
    dialog.setAttribute('aria-labelledby', 'schedule-editor-title');
    dialog.innerHTML = `<header class="schedule-editor-header"><div><h3 id="schedule-editor-title">Редагувати графік</h3><p>Щотижневий розклад · зміни застосовуються до всіх тижнів</p></div><button type="button" class="event-button event-icon-button" data-schedule-close aria-label="Закрити"><i class="ri-close-line"></i></button></header><nav class="schedule-editor-days" aria-label="День тижня">${short.map((name, i) => `<button type="button" class="sub-tab-button" data-schedule-day="${i}">${name}</button>`).join('')}</nav><div class="schedule-editor-tools"><strong id="schedule-editor-day-title"></strong><button type="button" class="event-button" data-schedule-add><i class="ri-add-line"></i> Додати слот</button><button type="button" class="event-button" data-schedule-copy><i class="ri-file-copy-line"></i> Копіювати день</button></div><div class="schedule-copy-options" hidden><span>Замінити графік у вибраних днях:</span><div>${short.map((name, i) => `<label><input type="checkbox" value="${i}" data-copy-day> ${name}</label>`).join('')}</div><button type="button" class="event-button event-button-primary" data-copy-confirm>Копіювати</button><button type="button" class="event-button" data-copy-cancel>Скасувати</button></div><div class="schedule-editor-columns"><span>Назва</span><span>Початок</span><span>Кінець</span><span>Категорія</span><span>Фіксація</span><span></span></div><div id="schedule-editor-rows"></div><p class="schedule-editor-hint"><i class="ri-lock-line"></i> Фіксація захищає від випадкового перетягування. Час і назву можна редагувати тут.</p><p id="schedule-editor-error" role="alert"></p><footer class="schedule-editor-footer"><button type="button" class="event-button" data-schedule-close>Скасувати</button><button type="button" class="event-button event-button-primary" data-schedule-save>Зберегти графік</button></footer>`;
    document.body.appendChild(dialog);
    const error = (text: string) => {
        dialog.querySelector('#schedule-editor-error')!.textContent = text;
    };
    function render() {
        dialog.querySelectorAll<HTMLElement>('[data-schedule-day]').forEach((button) => {
            button.classList.toggle('active', Number(button.dataset.scheduleDay) === day);
            button.setAttribute('aria-pressed', String(Number(button.dataset.scheduleDay) === day));
        });
        dialog.querySelector('#schedule-editor-day-title')!.textContent = days[day];
        const list = draft
            .filter((task) => task.dayIndex === day && !task.calendarRecoveryFor)
            .sort((a, b) => minutes(a.startTime) - minutes(b.startTime));
        dialog.querySelector('#schedule-editor-rows')!.innerHTML =
            list
                .map(
                    (task) =>
                        `<div class="schedule-editor-row" data-slot-id="${escape(task.id)}"><label><span>Назва</span><input data-slot-field="title" value="${escape(task.title)}" maxlength="150" aria-label="Назва слоту"></label><label><span>Початок</span><input type="text" inputmode="numeric" maxlength="5" placeholder="08:00" data-slot-field="startTime" value="${task.startTime}" aria-label="Початок слоту"></label><label><span>Кінець</span><input type="text" inputmode="numeric" maxlength="5" placeholder="17:00" data-slot-field="endTime" value="${task.endTime}" aria-label="Кінець слоту"></label><label><span>Категорія</span><select data-slot-field="category" aria-label="Категорія слоту">${Object.entries(
                            categories
                        )
                            .map(
                                ([value, title]) =>
                                    `<option value="${value}" ${task.category === value ? 'selected' : ''}>${title}</option>`
                            )
                            .join(
                                ''
                            )}</select></label><button type="button" class="event-button schedule-lock-toggle ${task.isFixed ? 'is-fixed' : ''}" data-slot-lock="${escape(task.id)}" aria-pressed="${task.isFixed}" aria-label="${task.isFixed ? 'Зняти фіксацію' : 'Зафіксувати'}"><i class="${task.isFixed ? 'ri-lock-line' : 'ri-lock-unlock-line'}"></i><span>${task.isFixed ? 'Фіксований' : 'Рухомий'}</span></button><button type="button" class="event-button event-icon-button event-delete" data-slot-delete="${escape(task.id)}" aria-label="Видалити слот"><i class="ri-delete-bin-line"></i></button></div>`
                )
                .join('') ||
            '<div class="schedule-editor-empty">У цей день слотів немає. Додайте слот або скопіюйте графік іншого дня.</div>';
        dialog.querySelectorAll<HTMLInputElement>('[data-copy-day]').forEach((input) => {
            input.disabled = Number(input.value) === day;
            if (input.disabled) input.checked = false;
        });
    }
    dialog.addEventListener('focusout', (event) => {
        const input = (event.target as HTMLElement).closest<HTMLInputElement>(
            '[data-slot-field="startTime"], [data-slot-field="endTime"]'
        );
        if (!input) return;
        input.value = normalizeTime(input.value);
        input.dispatchEvent(new Event('input', { bubbles: true }));
    });
    dialog.addEventListener('input', (event) => {
        const input = (event.target as HTMLElement).closest<HTMLInputElement | HTMLSelectElement>(
                '[data-slot-field]'
            ),
            row = input?.closest<HTMLElement>('[data-slot-id]');
        if (!input || !row) return;
        const task = draft.find((task) => task.id === row.dataset.slotId);
        if (!task) return;
        if (input.dataset.slotField === 'startTime' || input.dataset.slotField === 'endTime') {
            if (/^\d{4}$/.test(input.value)) input.value = normalizeTime(input.value);
        }
        (task as any)[input.dataset.slotField!] =
            input.dataset.slotField === 'endTime' && input.value === '00:00'
                ? '24:00'
                : input.value;
        error('');
    });
    dialog.addEventListener('click', async (event) => {
        const button = (event.target as HTMLElement).closest<HTMLElement>('button');
        if (!button) return;
        if ('scheduleClose' in button.dataset) {
            dialog.close();
            return;
        }
        if (button.dataset.scheduleDay) {
            day = Number(button.dataset.scheduleDay);
            error('');
            render();
        }
        if ('scheduleAdd' in button.dataset) {
            const list = draft.filter((task) => task.dayIndex === day && !task.calendarRecoveryFor);
            const end = Math.max(
                540,
                ...list.map((task) => minutes(task.endTime)).filter(Number.isFinite)
            );
            const start = Math.min(end, 1380);
            const clock = (n: number) =>
                `${String(Math.floor(n / 60)).padStart(2, '0')}:${String(n % 60).padStart(2, '0')}`;
            const id = slotId();
            draft.push({
                id,
                title: 'Новий слот',
                dayIndex: day,
                startTime: clock(start),
                endTime: clock(Math.min(1440, start + 60)),
                durationMins: 60,
                category: 'other',
                isFixed: false,
                allowSplit: false,
                priority: 'medium',
                status: 'planned',
            });
            render();
            dialog.querySelector<HTMLInputElement>(`[data-slot-id="${id}"] input`)?.focus();
        }
        if (button.dataset.slotLock) {
            const task = draft.find((task) => task.id === button.dataset.slotLock);
            if (task) {
                task.isFixed = !task.isFixed;
                task.allowSplit = !task.isFixed && task.category === 'delivery';
                render();
            }
        }
        if (button.dataset.slotDelete) {
            draft = draft.filter((task) => task.id !== button.dataset.slotDelete);
            render();
        }
        if ('scheduleCopy' in button.dataset)
            (dialog.querySelector('.schedule-copy-options') as HTMLElement).hidden = false;
        if ('copyCancel' in button.dataset)
            (dialog.querySelector('.schedule-copy-options') as HTMLElement).hidden = true;
        if ('copyConfirm' in button.dataset) {
            const targets = Array.from(
                dialog.querySelectorAll<HTMLInputElement>('[data-copy-day]:checked')
            ).map((input) => Number(input.value));
            const originals = draft.filter(
                (task) => task.dayIndex === day && !task.calendarRecoveryFor
            );
            draft = draft.filter(
                (task) => !targets.includes(task.dayIndex) || !!task.calendarRecoveryFor
            );
            for (const target of targets)
                draft.push(
                    ...originals.map((task) => ({
                        ...structuredClone(task),
                        id: slotId(),
                        dayIndex: target,
                        status: 'planned' as const,
                    }))
                );
            (dialog.querySelector('.schedule-copy-options') as HTMLElement).hidden = true;
            error(
                targets.length
                    ? 'Графік скопійовано. Натисніть «Зберегти графік», щоб застосувати.'
                    : 'Оберіть дні для копіювання.'
            );
        }
        if ('scheduleSave' in button.dataset) {
            for (const task of draft.filter((task) => !task.calendarRecoveryFor)) {
                const start = minutes(task.startTime),
                    end = minutes(task.endTime);
                if (
                    !task.title.trim() ||
                    !Number.isFinite(start) ||
                    !Number.isFinite(end) ||
                    end <= start ||
                    start >= 1440
                ) {
                    day = task.dayIndex;
                    render();
                    error(
                        `${days[day]}: перевірте назву та час слоту «${task.title}». Завершення має бути після початку.`
                    );
                    return;
                }
                task.title = task.title.trim();
                task.durationMins = end - start;
                task.allowSplit = !task.isFixed && task.category === 'delivery';
            }
            for (let index = 0; index < 7; index++) {
                const list = draft
                    .filter((task) => task.dayIndex === index && !task.calendarRecoveryFor)
                    .sort((a, b) => minutes(a.startTime) - minutes(b.startTime));
                for (let i = 1; i < list.length; i++) {
                    if (minutes(list[i].startTime) < minutes(list[i - 1].endTime)) {
                        day = index;
                        render();
                        error(
                            `${days[index]}: «${list[i - 1].title}» перетинається з «${list[i].title}». Змініть час одного зі слотів.`
                        );
                        return;
                    }
                }
            }
            (button as HTMLButtonElement).disabled = true;
            error('');
            try {
                if (await save(structuredClone(draft))) dialog.close();
                else error('Не вдалося зберегти графік. Спробуйте ще раз.');
            } catch {
                error('Не вдалося зберегти графік. Спробуйте ще раз.');
            } finally {
                (button as HTMLButtonElement).disabled = false;
            }
        }
    });
    dialog.addEventListener('close', () => dialog.remove());
    render();
    dialog.showModal();
    if (focusId) {
        const row = dialog.querySelector<HTMLElement>(`[data-slot-id="${CSS.escape(focusId)}"]`);
        row?.classList.add('is-highlighted');
        row?.scrollIntoView({ block: 'center' });
        row?.querySelector<HTMLInputElement>('input')?.focus();
    }
};
